import React, { useState, useEffect, useCallback } from 'react';
import { MessageCircle } from 'lucide-react';
import { Badge } from './ui/badge';
import api from '../services/api';

const MessagerieBadge = ({ onClick }) => {
  const [unreadCount, setUnreadCount] = useState(0);

  const loadUnreadCount = useCallback(async () => {
    try {
      const response = await api.get('/messagerie/non-lus');
      setUnreadCount(response.data?.count || 0);
    } catch (error) {
      console.error('Erreur chargement messages non lus:', error);
    }
  }, []);

  useEffect(() => {
    loadUnreadCount();
    // Rafraîchir toutes les 30 secondes
    const interval = setInterval(loadUnreadCount, 30000);
    return () => clearInterval(interval);
  }, [loadUnreadCount]);

  return (
    <button
      onClick={onClick}
      className="relative p-2 rounded-xl hover:bg-white/10 transition-colors"
      title="Messagerie"
    >
      <MessageCircle className="w-5 h-5" />
      {unreadCount > 0 && (
        <Badge className="absolute -top-1 -right-1 bg-red-500 text-white text-xs min-w-[18px] h-[18px] flex items-center justify-center p-0 rounded-full">
          {unreadCount > 9 ? '9+' : unreadCount}
        </Badge>
      )}
    </button>
  );
};

export default MessagerieBadge;
